import React from 'react';
import { motion } from 'framer-motion';
import { pageWrapperStyle } from '../../styles/pageStyles.js';
import './PolicyPage.css';

const SustainabilityPolicy = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, backgroundColor: 'var(--alt-background)' }}
    >
      <section className="policy-page section">
        <div className="container">
          <div className="policy-content">
            <h1>Sustainability Policy</h1>
            <p className="last-updated">Digital Fig Ltd<br/>Effective Date: 28 March 2026<br/>Review Cycle: Annually</p>

            <h2>1. Purpose</h2>
            <p>Digital Fig Ltd is committed to minimising environmental impact through efficient, low-footprint operations and responsible digital practices.</p>

            <h2>2. Environmental Commitments</h2>
            <h3>2.1 Low-Impact Operating Model</h3>
            <p>Digital Fig operates as a remote-first business, which:</p>
            <ul>
              <li>Eliminates commuting-related emissions</li>
              <li>Removes the need for energy-intensive office spaces</li>
              <li>Reduces overall operational carbon footprint</li>
            </ul>

            <h3>2.2 Digital-First Delivery</h3>
            <p>We prioritise fully digital workflows to reduce resource consumption:</p>
            <ul>
              <li>Communication via email, video conferencing, and cloud platforms</li>
              <li>Minimal to no reliance on printing or paper-based processes</li>
              <li>Secure digital storage and documentation</li>
            </ul>

            <h3>2.3 Efficient Technology Use</h3>
            <p>We aim to:</p>
            <ul>
              <li>Use energy-efficient hardware and hosting solutions where feasible</li>
              <li>Develop optimised websites that reduce server load and energy usage</li>
              <li>Avoid unnecessary or resource-intensive digital practices</li>
            </ul>

            <h3>2.4 Enabling Sustainable Outcomes for Clients</h3>
            <p>Our services contribute to wider sustainability by:</p>
            <ul>
              <li>Helping businesses operate and transact online</li>
              <li>Reducing reliance on physical materials and printed media</li>
              <li>Supporting efficient, scalable digital systems</li>
            </ul>

            <h3>2.5 Responsible Growth</h3>
            <p>As the business scales, Digital Fig is committed to:</p>
            <ul>
              <li>Maintaining a lean, low-impact infrastructure</li>
              <li>Exploring environmentally responsible suppliers and partners</li>
              <li>Continuously improving operational efficiency</li>
            </ul>

            <h2>3. Measurable Intent</h2>
            <p>Digital Fig aims to:</p>
            <ul>
              <li>Maintain a paperless operational model</li>
              <li>Sustain a remote-first structure to minimise emissions</li>
              <li>Improve efficiency of digital products over time</li>
            </ul>

            <h2>4. Review and Accountability</h2>
            <p>This policy is reviewed annually to ensure continued relevance and alignment with environmental best practices.</p>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default SustainabilityPolicy;
